import { timeout } from '../constants'
import Dynamic from '../dynamic/Dynamic'
import { Device } from '../helpers/Device'
import PrebidFacade from '../prebidFacade/PrebidFacade'
import SlotFactory from '../slots/SlotFactory'

export interface IHintConfig {
  desktopSelector: string
  mobileSelector: string
  slot?: SlotClass
  slotFactory: SlotFactory
  prebidFacade: PrebidFacade
}
export class Hint {
  /** This attribute acts as a mutex.
   * It is added onto a hint div once
   * a slot is inserted.
   */
  private static readonly INSERTED_SLOT_ATTRIBUTE = 'data-hint-slot-inserted'

  private constructor() {
    throw Error('Singleton class. Do not instantiate.')
  }

  static getHintParagraphs(
    config: Pick<IHintConfig, 'mobileSelector' | 'desktopSelector'>
  ): Array<Element> {
    const hintParagraphs = Array.from(
      document.querySelectorAll(
        Device.isMobileOrTablet ? config.mobileSelector : config.desktopSelector
      )
    )

    return hintParagraphs
  }

  static addSlotsToHints(config: IHintConfig): boolean {
    const hintParagraphs = Hint.getHintParagraphs(config)
    let didAdSlot = false
    if (!hintParagraphs || !hintParagraphs.length) {
      return didAdSlot
    }

    for (const paragraph of hintParagraphs) {
      if (paragraph.getAttribute(Hint.INSERTED_SLOT_ATTRIBUTE) !== 'true') {
        didAdSlot = true

        const slot = config.slot
          ? config.slot
          : (capitalize(paragraph.getAttribute('data-slot')) as SlotClass)

        const newSlot = Dynamic.insertSlot(
          paragraph as HTMLElement,
          slot,
          config.slotFactory,
          config.prebidFacade
        )

        // If the slot is not lazy, we need to request bids for it.
        if (newSlot && !newSlot.lazy) {
          config.prebidFacade.requestBids([newSlot], timeout())
        }
        paragraph.setAttribute(Hint.INSERTED_SLOT_ATTRIBUTE, 'true')
      }
    }

    return didAdSlot
  }
}

function capitalize(str: string | null): string | null {
  if (!str) {
    return str
  }

  return str.charAt(0).toUpperCase() + str.slice(1)
}
